import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { Client } from '@/models/client'
import api from '@/shared/api'
import { ENDPOINTS } from '@/shared/constants'
import { toast } from 'react-toastify'

interface ClientsState {
  clients: Client[]
  loading: boolean
  error: string | null
}

// Estado inicial
const initialState: ClientsState = {
  clients: [],
  loading: false,
  error: null,
}

// Função para buscar itens da API
export const fetchClients = createAsyncThunk<Client[]>(
  'clients/fetchClients',
  async (_, thunkAPI) => {
    try {
      const response = await api.get(ENDPOINTS.CLIENTS.GET.ALL)

      return (await response.data) as Client[]
    } catch (error: unknown) {
      toast.error('Erro ao listar listas de clientes')
      let errorMessage = 'Unknown error'

      if (error instanceof Error) {
        errorMessage = error.message
      }

      return thunkAPI.rejectWithValue(errorMessage)
    }
  }
)

// Slice
const clientsSlice = createSlice({
  name: 'clients',
  initialState,
  reducers: {
    // Exemplo de reducer adicional, se necessário
    clearError(state) {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClients.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        fetchClients.fulfilled,
        (state, action: PayloadAction<Client[]>) => {
          state.loading = false
          state.clients = action.payload
        }
      )
      .addCase(fetchClients.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})

// Exporta ações e reducer
export const { clearError } = clientsSlice.actions
export default clientsSlice.reducer
